"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INVALID_NUMERIC_VALUES = void 0;
var INVALID_NUMERIC_VALUES = exports.INVALID_NUMERIC_VALUES = ['e', 'E', '+'];